<div class='map-body flexColumn' [ngStyle]='style'>
  <div class='tool-body flexRow'>
    <!--    <label class="search-label">关键字搜索：</label>-->
    <!--    <nz-input-group [nzSuffix]="searchClear" class="search-group">-->
    <!--      <input type="text" nz-input [(ngModel)]="search" (blur)="searchData()" (keyup.enter)="$event.target.blur()" />-->
    <!--    </nz-input-group>-->
    <!--    <button nz-button nzType="primary" type="button" class="search-button clickEle"><i nz-icon nzIconfont="icon_search"></i></button>-->
    <!--    <ng-template #searchClear>-->
    <!--      <i nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" *ngIf="search" (click)="search = ''"></i>-->
    <!--    </ng-template>-->
    <label class='search-label'>坐标获取结果：</label>
    <nz-input-group [nzSuffix]='resultClear' class='result-group selfRadius'>
      <input type='text' nz-input [ngModel]='result' readonly />
    </nz-input-group>
    <ng-template #resultClear>
      <!--      <i nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"-->
      <!--         *ngIf="result"-->
      <!--         (click)="result = ''"></i>-->
    </ng-template>
    <div class='flexFull'></div>
    <button nz-button nzType='primary' (click)='backPoint()' class='mr-lg'>返回定位</button>
  </div>
  <div id='map' class='flexFull' [ngStyle]="{ width: style['width'] }"></div>
</div>
